import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const getBounceClass = ind => classNames(
  styles.bounce,
  styles[`bounce${ind}`],
)

const LoadingBubbles = (props) => {
  const { color, style } = props

  const rootClass = classNames(
    styles.root,
    'loading-dots',
  )

  return (
    <span className={rootClass} style={style}>
      <div className={`${getBounceClass(1)} bounce1`} style={{ backgroundColor: color }} />
      <div className={`${getBounceClass(2)} bounce2`} style={{ backgroundColor: color }} />
      <div className={`${getBounceClass(3)} bounce3`} style={{ backgroundColor: color }} />
    </span>
  )
}

LoadingBubbles.propTypes = {
  color: PropTypes.string,
  style: PropTypes.object,
}

LoadingBubbles.defaultProps = {
  color: '#e78d2d',
  style: {},
}

export default LoadingBubbles
